<template>
  <div class="collect-page">
    <el-card>
      <el-space wrap>
        <el-button type="primary" @click="trigger('market')">采集行情</el-button>
        <el-button type="primary" @click="trigger('news')">采集新闻</el-button>
        <el-button type="primary" @click="trigger('notice')">采集公告</el-button>
        <el-button type="primary" @click="openDragonDialog">龙虎榜采集</el-button>
        <el-button type="primary" @click="openHotImportDialog">同花顺龙虎热榜</el-button>
      </el-space>
    </el-card>
    <el-dialog v-model="dragonDialogVisible" title="龙虎榜采集" width="400px">
      <el-form label-width="90px">
        <el-form-item label="下载日期">
          <el-date-picker v-model="dragonDate" type="date" placeholder="选择日期" format="YYYY-MM-DD" value-format="YYYY-MM-DD" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dragonDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="dragonSubmitting" @click="submitDragon">提交</el-button>
      </template>
    </el-dialog>

    <el-dialog v-model="hotDialogVisible" title="同花顺游资机构龙虎热榜采集" width="420px">
      <el-form label-width="110px">
        <el-form-item label="日期">
          <el-date-picker v-model="hotDate" type="date" placeholder="选择日期" format="YYYY-MM-DD" value-format="YYYY-MM-DD" />
        </el-form-item>
        <el-form-item label="每页条数">
          <el-select v-model="hotSize" style="width: 160px">
            <el-option :label="'50'" :value="50" />
          </el-select>
        </el-form-item>
        <el-form-item label="最多抓取页数">
          <el-select v-model="hotMaxPages" style="width: 160px">
            <el-option :label="'5'" :value="5" />
            <el-option :label="'10'" :value="10" />
            <el-option :label="'20'" :value="20" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="hotDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="hotSubmitting" @click="submitHotImport">提交</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import request from '../../utils/request';
import stockClient from '../../utils/stockClient';

const trigger = async (type) => {
  try {
    if (type === 'news') {
      const res = await stockClient.post('/update-news', null, { params: { day: 50 } })
      await ElMessageBox.alert(JSON.stringify(res.data), '提示')
    } else {
      await request.post('/v1/stock/collect', { type });
      ElMessage.success('已触发');
    }
  } catch (e) {
    ElMessage.error(e.toString());
  }
};

const dragonDialogVisible = ref(false);
const dragonDate = ref('');
const dragonSubmitting = ref(false);

const openDragonDialog = () => {
  dragonDate.value = '';
  dragonDialogVisible.value = true;
};

const submitDragon = async () => {
  if (!dragonDate.value) {
    ElMessage.warning('请选择日期');
    return;
  }
  const date = String(dragonDate.value).replace(/-/g, '');
  dragonSubmitting.value = true;
  try {
    const res = await stockClient.post('/save', { date });
    await ElMessageBox.alert(JSON.stringify(res.data), '提示');
    dragonDialogVisible.value = false;
  } catch (e) {
    ElMessage.error(e.toString());
  } finally {
    dragonSubmitting.value = false;
  }
};

// 同花顺游资机构龙虎热榜采集
const hotDialogVisible = ref(false);
const hotDate = ref('');
const hotSize = ref(50);
const hotMaxPages = ref(5);
const hotSubmitting = ref(false);

const openHotImportDialog = () => {
  hotDate.value = '';
  hotSize.value = 50;
  hotMaxPages.value = 5;
  hotDialogVisible.value = true;
};

const submitHotImport = async () => {
  if (!hotDate.value) {
    ElMessage.warning('请选择日期');
    return;
  }
  hotSubmitting.value = true;
  try {
    const payload = {
      date: String(hotDate.value), // YYYY-MM-DD
      size: Number(hotSize.value) || 50,
      max_pages: Number(hotMaxPages.value) || 5
    };
    const resp = await stockClient.post('/hot_rank/import', payload);
    await ElMessageBox.alert(JSON.stringify(resp.data), '提示');
    hotDialogVisible.value = false;
  } catch (e) {
    ElMessage.error(e.toString());
  } finally {
    hotSubmitting.value = false;
  }
};
</script>

<style scoped>
.collect-page {
  padding: 20px;
}
</style>
